import {useEffect, useRef, useState} from "react";
import Image from "../Gallery/components/Image/Image";
import './style.scss';

const Lightbox = ({data, gallery, closeCB}) => {
    const [currentSrc, setCurrentSrc] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(null);
    const touchStartX = useRef(null);
    const touchMoved = useRef(false);

    useEffect(() => {
        setCurrentSrc(data?.src);
        setCurrentIndex(data?.index);
    }, [data]);

    const moveTo = (e , side) => {
        e.stopPropagation();
        const imgIndex = side === 'next' ? currentIndex + 1 : currentIndex - 1;
        if (imgIndex < 0 || imgIndex >= gallery.length) return;
        setCurrentSrc(gallery[imgIndex].public_id);
        setCurrentIndex(imgIndex);
    }

    const handleTouchStart = event => {
        touchStartX.current = event.touches[0].clientX;
        touchMoved.current = false;
    };

    const handleTouchEnd = event => {
        if (touchStartX.current === null) return;

        const distance = event.changedTouches[0].clientX - touchStartX.current;
        touchStartX.current = null;

        if (Math.abs(distance) < 45) return;

        touchMoved.current = true;
        const nextIndex = distance < 0 ? currentIndex + 1 : currentIndex - 1;
        if (nextIndex >= 0 && nextIndex < gallery.length) {
            setCurrentSrc(gallery[nextIndex].public_id);
            setCurrentIndex(nextIndex);
        }
    };

    const handleClick = () => {
        if (touchMoved.current) {
            touchMoved.current = false;
            return;
        }
        closeCB();
    };

    return (
        <div
            className='lightbox'
            onClick={handleClick}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            {currentIndex > 0  && <button className='left' onClick={e => moveTo(e,'prev')}>{'<'}</button>}
            <Image src={currentSrc}></Image>
            {currentIndex < gallery.length -1 && <button className='right' onClick={e => moveTo(e,'next')}>{'>'}</button>}
        </div>
    )
}

export default Lightbox;